import { z } from "zod";

/**
 * Mirrors the db enums (`conversation_status`, `conversation_control`) by
 * convention, not by import — `packages/shared` stays free of `@cos/db` so
 * it can be bundled into the widget. See PLAN.md "Conversation lifecycle is
 * a state machine" for what these two orthogonal fields mean.
 */
export const conversationStatusSchema = z.enum(["active", "escalated", "closed"]);
export type ConversationStatus = z.infer<typeof conversationStatusSchema>;

export const conversationControlSchema = z.enum(["bot", "human"]);
export type ConversationControl = z.infer<typeof conversationControlSchema>;
